import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";
import { fetchAppointmentTrends } from "../../../../redux/reducers/appointmentSlice";
import "./Appoint.css";
function AppointChart() {
  const dispatch = useDispatch();
  const { yearlyData, weeklyData, dailyData, loading } = useSelector(
    (state) => state.appointments
  );

  const [view, setView] = useState("Yearly");
  const [chartData, setChartData] = useState({
    categories: [],
    series: [],
  });

  useEffect(() => {
    dispatch(fetchAppointmentTrends());
  }, [dispatch]);

  useEffect(() => {
    if (loading) return;

    let categories = [];
    let data = [];

    if (view === "Yearly") {
      const year = "2025"; // or dynamically pick latest year
      const yearlyAppointments = yearlyData[year] || [];
      categories = yearlyAppointments.map((item) => item.month);
      data = yearlyAppointments.map((item) => item.appointments);
    } else if (view === "Weekly") {
      const weekKey = "Weekof14Jul2025"; // adjust logic if needed
      const weeklyAppointments = weeklyData[weekKey] || [];
      categories = weeklyAppointments.map((item) => item.date);
      data = weeklyAppointments.map((item) => item.appointments);
    } else if (view === "Daily") {
      const dayKey = "16Jul2025";
      const dailyAppointments = dailyData[dayKey] || { appointments: 0 };
      categories = [dayKey];
      data = [dailyAppointments.appointments];
    }

    setChartData({
      categories,
      series: [
        {
          name: "Appointments",
          data,
        },
      ],
    });
  }, [view, yearlyData, weeklyData, dailyData, loading]);

  const chartOptions = {
    chart: {
      type: "area",
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    stroke: {
      curve: "smooth",
      width: 2,
      colors: ["#3B3BFF"],
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.4,
        opacityTo: 0.1,
        stops: [0, 90, 100],
        colorStops: [],
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: chartData.categories,
      labels: {
        style: { fontSize: "12px" },
      },
    },
    yaxis: {
      tickAmount: 5,
      labels: {
        style: { fontSize: "12px" },
      },
    },
    tooltip: {
      custom: ({ series, seriesIndex, dataPointIndex, w }) => {
        const category = chartData.categories[dataPointIndex] || "";
        const appointments = series[seriesIndex][dataPointIndex];
        const revenue = (appointments * 37.27).toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 0,
        });

        return (
          '<div class="apexcharts-tooltip-title" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; background-color: #EBEBEB; color: #000; padding: 8px; margin: 0;">' +
          category +
          "</div>" +
          '<div class="apexcharts-tooltip-series-group" style="order: 1; display: flex; background-color: #fff; padding: 8px;">' +
          '<div class="apexcharts-tooltip-text" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #000;">' +
          '<div class="apexcharts-tooltip-y-group">' +
          '<span class="apexcharts-tooltip-text-y-label">Appointments: </span>' +
          '<span class="apexcharts-tooltip-text-y-value">' +
          appointments +
          "</span>" +
          "</div>" +
          '<div class="apexcharts-tooltip-y-group">' +
          '<span class="apexcharts-tooltip-text-y-label">Revenue: </span>' +
          '<span class="apexcharts-tooltip-text-y-value">' +
          revenue +
          "</span>" +
          "</div>" +
          "</div>" +
          "</div>"
        );
      },
    },
  };

  return (
    <div className="appointment-container">
      <div className="header">
        <div className="left">
          <h3>Appointment Trends</h3>
        </div>
        <ToggleButtonGroup
          value={view}
          exclusive
          onChange={(_, val) => val && setView(val)}
          size="small"
          sx={{
            backgroundColor: "#f0f2f5",
            borderRadius: "12px",
            "& .MuiToggleButtonGroup-grouped": {
              borderRadius: "7px",
              borderColor: "transparent",
              color: "#333",
              transition: "none",
              "&.Mui-selected": {
                backgroundColor: "#005EB8",
                color: "#fff",
              },
            },
          }}
        >
          <ToggleButton value="Daily">Daily</ToggleButton>
          <ToggleButton value="Weekly">Weekly</ToggleButton>
          <ToggleButton value="Yearly">Yearly</ToggleButton>
        </ToggleButtonGroup>
      </div>
      <Chart
        options={chartOptions}
        series={chartData.series}
        type="area"
        height={300}
      />
    </div>
  );
}

export default AppointChart;
